module.exports = __webpack_public_path__ + "static/media/head1.29feadec.png";